document.addEventListener("DOMContentLoaded", function () {
    const burgerBtn = document.querySelector(".burger-btn");
    if (burgerBtn) {
        burgerBtn.addEventListener('click', () => {
            document.querySelector(".burger-btn").classList.toggle("active");
            document.querySelector("body").classList.toggle("lock");
        });
    }
});
